import React from "react";
import { Avatar, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function AboutMe() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div style={{
      display: 'flex', 
      flexDirection: isMobile ? 'column' : 'row', 
      alignItems: 'center', 
      padding: isMobile ? '20px' : '40px', 
      height: '100%'
    }}>
      <Avatar 
        alt="Remy Sharp" 
        src={require("../assets/portrait.png")} 
        sx={{ 
          width: isMobile ? 150 : 500, 
          height: isMobile ? 200 : 650,
          marginBottom: isMobile ? '20px' : '0'
        }}
      />
      <div style={{
        textAlign: isMobile ? 'center' : 'left', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        paddingLeft: isMobile ? '0' : '50px'
      }}>
        <div>
          <Typography 
            variant={isMobile ? 'h3' : 'h1'} 
            style={{ marginBottom: '40px' }}
          >
            Nisanth Chilakamarri
          </Typography>
          <Typography variant={isMobile ? 'h5' : 'h3'}>
            Hi there:)
          </Typography>
        </div>
        <Typography 
          variant={isMobile ? 'body1' : 'h5'} 
          style={{ marginBottom: '20px' }}
        >
          Graduate student at the University at Buffalo, specializing in Computer Science with over two years of full-stack development experience.
        </Typography>
        <Typography variant={isMobile ? 'body1' : 'h5'}>
          Take a look at my work through the tabs.
        </Typography>
      </div>
    </div>
  );
}

export default React.memo(AboutMe);
